import { AddressEditor } from './address-editor';
import { ButtonSwitch } from './button-switch';
import { WebmoduleAutoSaveIndicator } from '../context/autoSaveNotifier';

export const webcomponentRegistry = {
  addressEditor: AddressEditor,
  buttonSwitch: ButtonSwitch,
  webmoduleAutoSaveIndicator: WebmoduleAutoSaveIndicator
};
